<template>
  <div class="policyInfo">
    <div class="info">
      <div class="info-title" v-if="type == 'policy'">当前位置：政策扶持</div>
      <div class="info-title" v-if="type == 'park'">当前位置：园区动态</div>
      <div class="info-title" v-if="type == 'kehui'">当前位置：出彩科慧</div>
      <div class="info-content">
        <div style="display: flex; align-items: center">
          <img
            src="../assets/other/focusNews.png"
            style="width: 48px; height: 27px"
          />
          <span
            style="
              font-size: 30px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #010101;
              margin-left: 11px;
            "
            >{{ info.title }}</span
          >
        </div>
        <div
          style="
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #9e9e9e;
            margin-bottom: 47px;
            margin-top: 34px;
          "
        >
          <span>{{ info.createTime }}</span>
          <span>编辑：{{ info.createBy }}</span>
        </div>
        <div v-html="info.noticeContent" class="article"></div>
      </div>
    </div>
    <div class="list">
      <div class="list-title" v-if="type == 'park'">园区动态</div>
      <div class="list-title" v-if="type == 'policy'">政策扶持</div>
      <div class="list-title" v-if="type == 'kehui'">出彩科慧</div>
      <div class="list-content">
        <div style="display: flex" v-for="i in listNav" :key="i.noticeId">
          <div
            style="
              width: 5px;
              height: 5px;
              background: #cccccc;
              margin-top: 7px;
            "
          ></div>
          <span
            style="
              font-size: 18px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #010101;
              margin-left: 15px;
              margin-bottom: 47px;
              cursor: pointer;
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              line-clamp: 2;
              -webkit-box-orient: vertical;
            "
            @click="listNavClick(i)"
            >{{ i.title }}</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { informationId, information } from "../api/home";
export default {
  data() {
    return {
      noticeId: this.$route.params.noticeId,
      info: {},
      type: this.$route.params.type,
      pageNum: 1,
      pageSize: 10,
      noticeType: 4,
      listNav: [],
    };
  },
  methods: {
    listNavClick(i) {
      this.noticeId = i.noticeId;
      this.informationId();
    },
    information() {
      if (this.type == "park") {
        this.noticeType = 1;
      } else if (this.type == "policy") {
        this.noticeType = 4;
      } else {
        this.noticeType = 5;
      }
      information({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        noticeType: this.noticeType,
      }).then((res) => {
        if (res.code == 200) {
          this.listNav = res.data.rows;
        }
      });
    },
    informationId() {
      informationId(this.noticeId).then((res) => {
        if (res.code == 200) {
          this.info = res.data;
        }
      });
    },
  },
  created() {
    this.informationId();
    this.information();
  },
};
</script>

<style lang="less">
.policyInfo {
  padding: 20px 0 0 0;
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  .info {
    flex: 2.7;
    .info-title {
      padding: 30px 0;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #9e9e9e;
      border-bottom: 1px dashed #ccc;
    }
    .info-content {
      width: 853px;
      padding-top: 71px;
    }
  }
  .list {
    margin-top: 83px;
    margin-left: 30px;
    flex: 1;
    .list-title {
      padding: 23px 0 23px 25px;
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #e60e0e;
      line-height: 30px;
      opacity: 0.8;
      background: linear-gradient(
        68deg,
        rgba(230, 14, 14, 0.02) 0%,
        rgba(230, 14, 14, 0.3) 100%
      );
    }
    .list-content {
      padding: 24px 30px;
      background: #fafafa;
    }
  }
  img {
    max-width: 853px;
  }
  p {
    font-size: 16px;
    line-height: 30px;
  }

  //公共样式
}
</style>